import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';

type Result<T> = { ok: boolean; data?: T; error?: string };
type State<T> = { loading: boolean; data?: T; error?: string };

/**
 * Run `loader` whenever `deps` change; expose loading/data/error.
 */
export function useAnalyticsData<T>(loader: () => Promise<Result<T>>, deps: any[]): State<T> {
  const [state, setState] = useState<State<T>>({ loading: true });

  useEffect(() => {
    let mounted = true;
    setState({ loading: true });
    loader().then((res) => {
      if (!mounted) return;
      if (res.ok) setState({ loading: false, data: res.data });
      else setState({ loading: false, error: res.error || 'Failed to load' });
    });
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}

export const Loadable: React.FC<{ loading: boolean; error?: string; children: React.ReactNode }> = ({
  loading,
  error,
  children,
}) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={6}>
        <CircularProgress />
      </Box>
    );
  }
  if (error) {
    return (
      <Box p={3}>
        <Typography color="error">Failed to load analytics: {error}</Typography>
      </Box>
    );
  }
  return <>{children}</>;
};
